import React from "react";
import CustomInput from "../../shared/CustomInput/CustomInput";
import { Box } from "@mui/material";
import "./PlaylistForm.scss";
import UnifiedButton from "../../shared/Button";

function PlaylistForm() {
    return (
        <Box className="playlist-form-section">
            <div className="form-row">
                <CustomInput
                    label="First Name"
                    placeholder="Enter your first name"
                    fullWidth
                />
                <CustomInput
                    label="Last Name"
                    placeholder="Enter your last name"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomInput label="Email" placeholder="Enter your email" fullWidth />
                <CustomInput
                    label="Mobile no."
                    placeholder="Enter your mobile number"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomInput
                    label="Song Name"
                    placeholder="Enter the song name"
                    fullWidth
                />
                <CustomInput
                    label="Store"
                    placeholder="Enter the store name"
                    fullWidth
                />
            </div>

            <Box
                sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
            >
                <UnifiedButton
                    className={"playlist-form-button"}
                    variant="contained"
                    textContent={"Submit"}
                    fullWidth
                    sx={{ mt: 2, color: "white" }}
                />
            </Box>
        </Box>
    );
}

export default PlaylistForm;
